import React, { useEffect, useMemo, useState } from 'react';

import { Card } from '../../../../components/Card';
import { Modal } from '../../../../components/Modal';
import { useReservationId } from '../../../../hooks/useReservationId';
import { useTransaction } from '../../../../hooks/useTransaction';
import { CheckupVacancyStore } from '../CheckupReservationsNew/CheckupReservationVacancySelect/stores/CheckupVacancyStore';
import { CheckupReservationStore } from '../CheckupReservationsNew/stores/CheckupReservationStore';
import { CheckupReservationBasicInfoEditPage } from './CheckupReservationEditBasicInfo';
import { CheckupReservationEditVacancySelectPage } from './CheckupReservationEditVacancySelect';

type STEPS = 'basicInfo' | 'vacancySelect';
export const CheckupReservationEditPage = () => {
  const [step, setStep] = useState<STEPS>('basicInfo');
  const store = useMemo(() => new CheckupReservationStore(), []);
  const vacancyStore = useMemo(() => new CheckupVacancyStore(), []);
  const { reservationId } = useReservationId();
  const [load, loadStatus] = useTransaction(() => store.fetchCheckupTreatmentInfo(reservationId));

  useEffect(() => {
    store.setMode('edit');
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const main = () => {
    switch (step) {
      case 'basicInfo':
      default:
        return <CheckupReservationBasicInfoEditPage onNext={() => setStep('vacancySelect')} />;
      case 'vacancySelect':
        return <CheckupReservationEditVacancySelectPage />;
    }
  };

  return (
    <CheckupReservationStore.Context.Provider value={store}>
      <CheckupVacancyStore.Context.Provider value={vacancyStore}>
        {loadStatus.running ? (
          <Modal visible>
            <Card>診察情報を取得中</Card>
          </Modal>
        ) : (
          main()
        )}
      </CheckupVacancyStore.Context.Provider>
    </CheckupReservationStore.Context.Provider>
  );
};
